// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import {NavLink, Link} from 'react-router-dom'

import CustomDropdown from '../../DropDown'

import {AUDITVIEWER_PATH} from '../../AuditViewer/navigation'
import config, {FEATURE_AUDIT_VIEWER, FEATURE_VCASCLOUD_DEVICES, FEATURE_VCASCLOUD_CONTENT, FEATURE_VCASCLOUD_ENTITLEMENTS, SHOW_DUMMY_LINKS} from '../../../config'

import './navigation.css'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import {VCASCLOUD_PATH, ENTITLEMENTS_PATH} from './VCASCloud/navigation'

export const MULTIDRM_PATH = 'multi-drm'

const audit_viewer_flag = config[FEATURE_AUDIT_VIEWER]
const devices_flag = config[FEATURE_VCASCLOUD_DEVICES]
const content_flag = config[FEATURE_VCASCLOUD_CONTENT]
const entitlements_flag = config[FEATURE_VCASCLOUD_ENTITLEMENTS]
const show_dummy_links = config[SHOW_DUMMY_LINKS]

export function multiDRMNavOptions (location) {
  let splittedLocation = location.split('/')
  let ddTriggerActive = splittedLocation[2]
  let ddItemActive = splittedLocation[3]

  let showVCASCloudDropdown = devices_flag || content_flag || entitlements_flag
  return (
    <ul className='multiDRMNav'>
      {showVCASCloudDropdown &&
        <li className='nav-item mr-3'>
          <CustomDropdown dropdownTrigger={<>VCAS Cloud <ExpandMoreIcon /></>} dropdownTriggerClassname={ddTriggerActive === VCASCLOUD_PATH ? 'active' : ''}>
            <div className='row'>
              <div className='col-md-6'>
                <ul>
                  <li className='title trouble-shoot'> Trouble Shoot </li>
                  <li className={`item ${ddItemActive === ENTITLEMENTS_PATH ? 'active' : ''}`}>
                    <Link className='dropdown' to={`/${MULTIDRM_PATH}/${VCASCLOUD_PATH}/${ENTITLEMENTS_PATH}/`}>Entitlements</Link>
                  </li>
                  { show_dummy_links &&
                  <li className='item'>
                    <Link className='dropdown' to={`/`}>Activity Log</Link>
                  </li>
                  }
                </ul>
              </div>
              { show_dummy_links &&
              <div className='offset-md-1 col-md-5'>
                <ul>
                  <li className='title configure'> Configure </li>
                  <li className='item'>
                    <Link className='dropdown' to={`/`}>Server</Link>
                  </li>
                </ul>
              </div>
              }
            </div>
          </CustomDropdown>
        </li>
      }
      {audit_viewer_flag &&
      <li className='nav-item mr-3'>
        <NavLink exact to={`/${MULTIDRM_PATH}/${AUDITVIEWER_PATH}/`}>Audit Viewer </NavLink>
      </li>}
      <li className='nav-item mr-3'>
        <NavLink exact to={`/${MULTIDRM_PATH}/`}>System Status</NavLink>
      </li>
    </ul>
  )
}
